import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

import { RichText } from 'components/ContentfulContent/RichText/RichText';

import { Document } from '@contentful/rich-text-types';

const RichTextBlockWrapper = styled('div')(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  padding: `${theme.spacing(4)} 15% ${theme.spacing(4)} 0`,
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

export function RichTextBlock({ document }: { document?: Document }) {
  return (
    <Container>
      <RichTextBlockWrapper>
        <RichText document={document}></RichText>
      </RichTextBlockWrapper>
    </Container>
  );
}
